module.exports = __webpack_public_path__ + "Lato-Black.77d353744697c77955f9";


//////////////////
// WEBPACK FOOTER
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/assets/fonts/Lato/Lato-Black.ttf
// module id = ../../../../../src/assets/fonts/Lato/Lato-Black.ttf
// module chunks = styles